import React from 'react';
import Text from '../../../elements/Text';
import { T } from '../../../helpers/i18n';
import cxs from 'cxs/component';
export const BlockDataContact = ({ ticket }) => {
    const isEmpty = (value) => {
        return !!!value;
    };
    const contactIsEmpty = (value) => {
        if (!value) {
            return true;
        }
        return isEmpty(value.name) && isEmpty(value.surname) && isEmpty(value.telephone) && isEmpty(value.email) && isEmpty(value.additionalInformation);
    };
    if (!ticket || !ticket.contact) {
        return null;
    }
    const { contact } = ticket;
    return (React.createElement(React.Fragment, null,
        !contactIsEmpty(contact) && React.createElement(Text, { big: true, center: true }, 'Datos de contacto'),
        (contact.name && contact.name !== '' || contact.surname && contact.surname !== '') &&
            React.createElement(WrapperSpan, null,
                React.createElement("span", { style: { fontWeight: 'bold', textAlign: 'start' } },
                    T('mr_mrs'),
                    ": "),
                React.createElement("span", null,
                    contact.name ? contact.name : '',
                    " ",
                    contact.surname ? contact.surname : '')),
        contact.telephone && contact.telephone !== '' &&
            React.createElement(WrapperSpan, null,
                React.createElement("span", { style: { fontWeight: 'bold' } },
                    T('telephone'),
                    ": "),
                React.createElement("span", null, contact.telephone)),
        contact.email && contact.email !== '' &&
            React.createElement(WrapperSpan, { style: { width: '100%' } },
                React.createElement("span", { style: { fontWeight: 'bold' } },
                    T('email'),
                    ": "),
                " ",
                React.createElement("span", null,
                    " ",
                    contact.email)),
        contact.additionalInformation && contact.additionalInformation !== '' &&
            React.createElement(WrapperSpan, { style: { width: '100%' } },
                React.createElement("span", { style: { fontWeight: 'bold' } },
                    T('additionalInformation'),
                    ": "),
                React.createElement("span", null, contact.additionalInformation))));
};
const WrapperSpan = cxs('span')({
    width: '100%'
});



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockDataContact.tsx
// module id = 527
// module chunks = 0